import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";

import { IIcon } from "./icons-interfaces";


const PadlockSvg = () => (

	<svg
		width="1em"
		height="1em"
		viewBox="0 0 1024 1024"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title />
		<g id="icomoon-ignore" />
		<path d="M704 448h-32v-96c0-88.224-71.776-160-160-160s-160 71.776-160 160v96h-32c-35.296 0-64 28.704-64 64v320c0 35.296 28.704 64 64 64h384c35.296 0 64-28.704 64-64v-320c0-35.296-28.704-64-64-64zM416 352c0-52.928 43.072-96 96-96s96 43.072 96 96v96h-192v-96zM512 736c-35.296 0-64-28.704-64-64 0-23.04 12.192-43.328 30.432-54.624v-9.376c0-17.664 14.336-32 32-32h3.136c17.664 0 32 14.336 32 32v9.376c18.24 11.296 30.432 31.584 30.432 54.624 0 35.296-28.704 64-64 64z" />
	</svg>

);

const PadlockIcon: FunctionComponent<IIcon> = (): JSX.Element => {
	return <Icon component={ PadlockSvg } />;
};


export default PadlockIcon;
